export default {
  name: 'ChartCard',
  props: ['title', 'total', 'loading']
};